import { render, staticRenderFns } from "./CloneIngredientDialog.vue?vue&type=template&id=7cd769b0&"
import script from "./CloneIngredientDialog.vue?vue&type=script&lang=js&"
export * from "./CloneIngredientDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports